import{j as e}from"./chunk-GEPA7FLG.js";e();import{gql as s}from"@apollo/client";var r=s`
  query account_details($address: String!) {
    accountDetails(address: $address) {
      address
      egldBalance
      esdtTokens {
        name
        identifier
        balance
        decimals
        ticker
        assets {
          svgUrl
          pngUrl
        }
      }
      lockedTokens {
        collection
        tokens {
          name
          collection
          identifier
          balance
          decimals
          ticker
          nonce
          assets {
            svgUrl
            pngUrl
          }
          unlockSchedule {
            epoch
            percent
            unlockDate
          }
        }
      }
      farmTokens {
        name
        identifier
        balance
        decimals
        ticker
        assets {
          svgUrl
          pngUrl
        }
      }
    }
  }
`;export{r as a};
//# sourceMappingURL=chunk-LZ26RGRO.js.map
